import { useContext } from 'react'
import { HIDE_VIDEO_PDP_EXPERIMENT_ID } from 'src/components/common/StatsigExposure/StatsigExposure'
import { ProductContext } from 'src/components/restructure/product/contexts/product-context'
import { Statsig } from 'src/sdk/statsig'
import isYouTubeVideo from 'src/utils/youtube'

import { GalleryImageDesktop } from './GalleryDesktop'
import { GalleryImageMobile } from './GalleryMobile'

interface GalleryImagesProps {
  isAlbumGrid?: boolean
  showPresaleFlag?: boolean
  isFirstFoldRevampEnabled?: boolean
}

export const GalleryImage = ({
  isAlbumGrid = false,
  showPresaleFlag = false,
  isFirstFoldRevampEnabled = false,
}: GalleryImagesProps) => {
  const { currentSku, isPreSale } = useContext(ProductContext)

  const { images, videos } = currentSku

  const isHideVideoExperimentEnabled = Statsig.useStatsigFeatureGateValue(
    HIDE_VIDEO_PDP_EXPERIMENT_ID,
    false
  )

  const getVideoObject = () => {
    if (videos.length < 1) {
      return undefined
    }

    return {
      url: videos[0],
      videoType: isYouTubeVideo(videos[0]) ? 'youtube' : 'brightcove',
      label: currentSku.name,
    }
  }

  const video = isHideVideoExperimentEnabled ? undefined : getVideoObject()

  return (
    <>
      {images && (
        <>
          <GalleryImageMobile
            images={images}
            video={video}
            isPresale={showPresaleFlag && isPreSale}
            isFirstFoldRevampEnabled={isFirstFoldRevampEnabled}
          />
          <GalleryImageDesktop
            images={images}
            video={video}
            isAlbumGrid={isAlbumGrid}
            isPresale={showPresaleFlag && isPreSale}
          />
        </>
      )}
    </>
  )
}
